import { render, staticRenderFns } from "./IcReduction.vue?vue&type=template&id=388be012&scoped=true"
import script from "./IcReduction.vue?vue&type=script&lang=js"
export * from "./IcReduction.vue?vue&type=script&lang=js"
import style0 from "./IcReduction.vue?vue&type=style&index=0&id=388be012&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388be012",
  null
  
)

export default component.exports